import { useEffect } from "react";
import { FormControl, FormHelperText, Grid, MenuItem, Select, TextField } from "@mui/material";
import { t } from "i18next";
import { validateIP } from "../../../../helpers/functions/functions";
import UnitValues from "../../../../helpers/constants/UnitValues";
import TimeValues from "../../../../helpers/constants/TimeValues";
import InputPlus from "../../../../components/InputPlus";

function AddSiteForm({ formData, setFormData, errors, setErrors, isEdit }) {
  const { name, mgmtip, anycast, cachesizenum, cachesizeunit, inactivenum, inactiveunit } = formData;

  const handleChange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors({
      ...errors,
      [name]: null
    });
  };

  // checking ip validation onChange
  useEffect(() => {
    if (!validateIP(mgmtip) && mgmtip !== "") {
      setErrors({
        ...errors,
        mgmtip: t("message.format", { item: t("site.management_ip") })
      });
    }
  }, [mgmtip]);

  useEffect(() => {
    if (anycast[0] !== "" || (anycast[0] === "" && anycast.length > 1)) {
      const anycastError = [];

      anycast.map((a, i) => {
        if (!validateIP(anycast[i]) && anycast[i] !== "") {
          anycastError[i] = t("message.format", { item: t("site.anycast") });
        }
      });

      setErrors({
        ...errors,
        anycast: anycastError
      });
    }
  }, [anycast]);

  return (
    <>
      <Grid container spacing={2} className="mb-3">
        <Grid item md={5} xs={12}>
          <TextField id="name" label={t("site.site_name")} variant="outlined" fullWidth
                     value={name} disabled={isEdit} error={!!errors?.name} helperText={errors?.name}
                     onChange={(e) => handleChange("name", e.target.value)}
          />
        </Grid>

        <Grid item md={5} xs={12}>
          <TextField id="mgmtip" label={t("site.management_ip")} variant="outlined" fullWidth
                     value={mgmtip} error={!!errors?.mgmtip} helperText={errors?.mgmtip}
                     onChange={(e) => handleChange("mgmtip", e.target.value)}
          />
        </Grid>
      </Grid>

      <Grid container rowSpacing={3} className="mb-3">
        <InputPlus
           items={anycast}
           error={errors?.anycast}
           label={t("site.anycast")}
           handleChange={(e) => handleChange("anycast", e)}
        />
      </Grid>

      <Grid container spacing={2} className="mb-2">
        <Grid item md={5} xs={12}>
          <FormControl fullWidth>
            <Grid container>
              <Grid item md={6} xs={6} pr={1}>
                <TextField id="cachesizenum" label={t("site.cache_size")} variant="outlined" inputProps={{ min: 0 }} fullWidth
                           value={cachesizenum} error={!!errors.cachesizenum} type="number"
                           onChange={(e) => handleChange("cachesizenum", e.target.value)}
                />
              </Grid>

              <Grid item md={6} xs={6}>
                <Select
                   id="cachesizeunit"
                   value={cachesizeunit}
                   onChange={(e) => handleChange("cachesizeunit", e.target.value)}
                   error={!!errors.cachesizeunit}
                   fullWidth
                >
                  {UnitValues.map(({ name, value }, index) => {
                    return <MenuItem value={value} key={index}>{name}</MenuItem>
                  })}
                </Select>
              </Grid>
            </Grid>

            <FormHelperText error={!!(errors.cachesizeunit || errors.cachesizenum)}>
              {errors.cachesizeunit
                 ? errors.cachesizeunit
                 : (errors.cachesizenum
                       ? errors.cachesizenum
                       : ""
                 )
              }
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item md={5} xs={12}>
          <FormControl fullWidth>
            <Grid container>
              <Grid item md={6} xs={6} pr={1}>
                <TextField id="inactivenum" label={t("site.cache_inactive")} variant="outlined" inputProps={{ min: 0 }} fullWidth
                           value={inactivenum} error={!!errors.inactivenum} type="number"
                           onChange={(e) => handleChange("inactivenum", e.target.value)}
                />
              </Grid>

              <Grid item md={6} xs={6}>
                <Select
                   id="inactiveunit"
                   value={inactiveunit}
                   onChange={(e) => handleChange("inactiveunit", e.target.value)}
                   error={!!errors.inactiveunit}
                   fullWidth
                >
                  {TimeValues.map(({ name, value }, index) => {
                    if (value !== "y") return <MenuItem value={value} key={index}>{name}</MenuItem>
                  })}
                </Select>
              </Grid>
            </Grid>

            <FormHelperText error={!!(errors.inactiveunit || errors.inactivenum)}>
              {errors.inactiveunit
                 ? errors.inactiveunit
                 : (errors.inactivenum
                       ? errors.inactivenum
                       : ""
                 )
              }
            </FormHelperText>
          </FormControl>
        </Grid>
      </Grid>
    </>
  );
}

export default AddSiteForm;
